module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.448c34a56d699c29117a.woff2";


//////////////////
// WEBPACK FOOTER
// F:/Projects/tfs/VS2015/SolventC/SolventCWebsite/Angular4.Website/src/assets/fonts/glyphicons-halflings-regular.woff2
// module id = ../../../../../src/assets/fonts/glyphicons-halflings-regular.woff2
// module chunks = styles